/* eslint-disable react/prop-types */
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import RenderAction from './RenderAction';
import { Dropdown } from 'react-bootstrap';
import Backdrop from 'components/base/Backdrop';

const DropdownActions = ({ change_flag = 0, actions }) => {
  return (
    <RevealDropdownTrigger>
      <RevealDropdown
        className="position-relative h-100"
        btnClassName="phoenix-secondary border h-100"
        iconClassName="fs-9"
      >
        {actions?.map((action, i) => (
          <>
            {action.label === 'divider' ? (
              <Dropdown.Divider />
            ) : (
              <RenderAction
                key={`${i}-dropdown-action`}
                action={action}
                defaultLabel={'action'}
                defaultIcon={'mdi:block'}
                eventKey={1 + i}
              />
            )}
          </>
        ))}

        <Backdrop
          show={change_flag === '1'}
          className={
            'position-absolute flex justify-content-center rounded align-items-center'
          }
        >
          <p className="mb-0 text-warning-300 dark__text-warning-300 fs-9">
            Waiting for approval
          </p>
        </Backdrop>
      </RevealDropdown>
    </RevealDropdownTrigger>
  );
};

export default DropdownActions;
